var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoStack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 70,
    viewBox: "0 0 129 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.4 49.974s-.689-17.257-11.403-25.193c-10.714-7.935-24.204-7.928-24.204-7.928S47.932 46.523 70.4 49.974Z",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M70.403 49.974s4.917-11.326.477-19.775c-4.44-8.45-13.138-12.613-13.138-12.613s-.753 23.207 12.661 32.388Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M70.4 49.974S65.105 32.23 51.868 26.816c-13.236-5.414-27.23-1.85-27.23-1.85S46.139 52.33 70.4 49.974Z",
    fill: "url(#c)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.407 49.974s11.724-12.689 9.776-25.865C78.236 10.933 68.694 1.416 68.694 1.416s-11.731 30.26 1.713 48.558Z",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M70.4 49.974s11.512-4.53 14.344-13.644c2.833-9.114-.355-18.208-.355-18.208s-16.97 15.89-13.99 31.852Z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M70.407 49.974s8.793-16.302 3.241-29.447C68.097 7.38 55.65 0 55.65 0s-4.095 34.552 14.757 49.974Z",
    fill: "url(#f)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.206 59.492h-2.424a1.727 1.727 0 0 0-.492.045c.038-.161.063-.325.072-.49l.117-2.489h-.84l-.139 1.163c-.186 1.605-.466 1.861-2.099 1.91l-.583.023v.838h1.725c.173.01.346-.006.514-.049-.043.168-.059.341-.049.514v5.398c0 1.375.049 1.726.234 2.235.303.816 1.192 1.303 2.334 1.303A5.033 5.033 0 0 0 129 69.31l-.212-.977a3.96 3.96 0 0 1-1.819.441c-1.35 0-1.63-.464-1.63-2.605v-5.213a1.675 1.675 0 0 0-.049-.514c.168.043.341.06.514.05h2.402v-1.001Zm-12.859 3.722c-.445-.014-.89.01-1.331.072.352-1.888 1.539-2.983 3.241-2.983 1.702 0 2.871 1.133 3.026 2.983a2.819 2.819 0 0 0-.794-.072h-4.142Zm5.503 1 .651-.754c-.023-2.537-1.68-4.259-4.055-4.259-2.798 0-4.852 2.265-4.852 5.399 0 3.133 2.076 5.33 5.015 5.33a5.193 5.193 0 0 0 3.892-1.653l-.7-.755a4.156 4.156 0 0 1-2.984 1.23c-2.239 0-3.846-1.743-3.846-4.152v-.465c.432.058.869.08 1.305.068l5.574.012Zm-9.568-4.05a4.389 4.389 0 0 0-2.647-.929c-1.842 0-3.147 1.208-3.147 2.862 0 1.28.582 2 2.269 2.722l1.093.49c1.097.488 1.513.956 1.513 1.767 0 1.027-.84 1.726-2.076 1.726a3.673 3.673 0 0 1-2.704-1.235l-.677.933a4.237 4.237 0 0 0 3.267 1.393c2.073 0 3.472-1.208 3.472-3.002 0-1.347-.677-2.14-2.496-2.91-2.05-.884-2.402-1.186-2.402-2.092 0-.906.757-1.536 1.869-1.536.627 0 1.134.185 1.932.698l.257.162.477-1.05Zm-6.255-.514a3.757 3.757 0 0 0-1.63-.419c-.957 0-1.634.582-2.871 2.51l-.068-.022c-.023-1.28-.234-1.906-.794-2.488l-1.097.533c.583.536.723 1.234.723 3.352V69.8h1.331v-7.166c1.097-1.631 1.819-2.213 2.704-2.213.488.005.967.125 1.399.352l.303-1.122Zm-12.48.755c2.31 0 3.895 1.794 3.895 4.399 0 2.442-1.445 4.073-3.661 4.073-2.144 0-3.8-1.91-3.8-4.42 0-2.398 1.444-4.052 3.565-4.052Zm.162-1.132c-2.912 0-5.106 2.303-5.106 5.376 0 3.141 2.1 5.33 5.106 5.33 3.007 0 5.11-2.212 5.11-5.262 0-3.232-2.077-5.444-5.11-5.444ZM75.373 68.36h-.068c.044-.12.06-.25.045-.377V56.068a1.386 1.386 0 0 0-.045-.465c.487-.056.977-.079 1.467-.068a12.472 12.472 0 0 1 4.383.695c2.356.887 3.873 3.284 3.873 6.04a6.282 6.282 0 0 1-1.702 4.53c-1.134 1.133-3.15 1.749-5.642 1.749a12.216 12.216 0 0 1-1.842-.095l-.47-.094Zm-1.468-13.897v15.101c1.044.128 2.095.19 3.147.185 2.984 0 5.223-.51 6.577-1.487 1.91-1.374 2.938-3.538 2.938-6.097a7.861 7.861 0 0 0-2.496-5.89c-1.513-1.329-3.782-1.978-6.83-1.978-.794 0-1.634.023-2.45.09l-.379.05-.507.026Zm-5.597 15.2h2.682V53.485h-2.682v16.178Zm-4.36 0h2.685V53.485h-2.685v16.178Zm-8.23-6.683c.303-1.37 1.26-2.235 2.474-2.235a2.336 2.336 0 0 1 2.379 2.235h-4.852Zm6.157 1.7.957-1.326v-.234c0-2.42-1.936-4.259-4.455-4.259-3.056 0-5.317 2.398-5.317 5.663 0 3.19 2.193 5.47 5.25 5.47a5.917 5.917 0 0 0 4.537-1.838l-.934-1.442a4.543 4.543 0 0 1-2.984 1.133c-1.724 0-3.025-1.303-3.173-3.145l6.12-.023Zm-13.993.792L43.45 54.089l-2.772.536 2.057 5.26-2.401 6.146-4.686-11.942-2.844.536 6.051 15.038h2.213l2.798-7.124 2.844 7.124h2.194l5.99-15.038-2.647-.536-4.365 11.383ZM27.06 62.98c.303-1.37 1.26-2.235 2.474-2.235a2.336 2.336 0 0 1 2.378 2.235H27.06Zm6.157 1.7.957-1.326v-.234c0-2.42-1.936-4.259-4.455-4.259-3.056 0-5.317 2.398-5.317 5.663 0 3.19 2.193 5.47 5.245 5.47a5.92 5.92 0 0 0 4.538-1.838l-.934-1.442a4.543 4.543 0 0 1-2.984 1.133c-1.724 0-3.025-1.303-3.173-3.145l6.123-.023ZM19.39 66.264 16.614 59l-2.678.442 4.16 10.22h2.326l4.243-10.22L22.17 59l-2.78 7.264Zm-6.309-7.053h-2.68v10.45h2.68v-10.45Zm-1.259-4.772a1.553 1.553 0 0 0-1.441.95 1.546 1.546 0 0 0 1.13 2.117 1.553 1.553 0 0 0 1.85-1.53 1.508 1.508 0 0 0-.946-1.427 1.514 1.514 0 0 0-.593-.11Zm-8.978-.049H0v15.272h9.118l.348-2.42H2.844V54.39Z",
    fill: "#3A3C42"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 52.598,
    y1: 16.842,
    x2: 52.598,
    y2: 49.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2AD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EB129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 68.105,
    y1: 22.837,
    x2: 57.923,
    y2: 44.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009A84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#115CA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009639"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 43.079,
    y1: 19.29,
    x2: 51.947,
    y2: 53.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D31216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E35910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E03913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 13121.9,
    y1: -4625.52,
    x2: 12098.8,
    y2: -3600.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2AD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EB129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 87.56,
    y1: 30.601,
    x2: 65.25,
    y2: 38.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58256E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 72.271,
    y1: 10.08,
    x2: 54.169,
    y2: 40.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0CB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#009539"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStack);
export default __webpack_public_path__ + "static/media/logo-stack.eb2556e1031f65f67888d829a7cb1d3f.svg";
export { ForwardRef as ReactComponent };